module.exports = __webpack_public_path__ + "static/media/lait-de-soja.3f304ddb.svg";